import { render, staticRenderFns } from "./by_prt_ac.vue?vue&type=template&id=5bf6baff"
import script from "./by_prt_ac.vue?vue&type=script&lang=js"
export * from "./by_prt_ac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports